import React from 'react';
import Hero from './components/administration/dispensary/Hero';
import Main from './components/administration/dispensary/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Dispensary = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default Dispensary;